// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IAddressJob } from '~/utils/interface/job';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      address: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      address2: yup.string().trim().optional(),
      city: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      state: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      zipCode: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      country: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
    })
    .required();
};

export const defaultValuesForm: IAddressJob = {
  address: EMPTY_STRING,
  city: EMPTY_STRING,
  state: EMPTY_STRING,
  zipCode: EMPTY_STRING,
  country: EMPTY_STRING,
  address2: EMPTY_STRING,
};
